import { ScreenQuestionProps } from './types';

export const LANGUAGE_QUESTION_TEXT = 'What is your level of proficiency in this language?';

export const LANGUAGE_PROFICIENCY_SCALE = [
  { label: 'Basic', value: 'Basic', weight: 2 },
  { label: 'Intermediate', value: 'Intermediate', weight: 6 },
  { label: 'Fluent', value: 'Fluent', weight: 10 },
] as const;

export const LANGUAGE_PROFICIENCY_VALUE_MAP = LANGUAGE_PROFICIENCY_SCALE.reduce<
  Record<string, number>
>((acc, item) => {
  acc[item.value] = item.weight;
  return acc;
}, {});

const BASE_LANGUAGE_SCREEN_QUESTION: ScreenQuestionProps = {
  title: 'Language',
  question: LANGUAGE_QUESTION_TEXT,
  type: 'Language',
  category: 'PreDefined',
  answerType: 'SingleChoice',
  valueMap: LANGUAGE_PROFICIENCY_VALUE_MAP,
  options: LANGUAGE_PROFICIENCY_SCALE.map(({ label, value }) => ({ label, value })),
};

export const LANGUAGE_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_LANGUAGE_SCREEN_QUESTION,
  required: true,
};

export const createLanguageQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => {
  const language = overrides.language ?? '';
  const expected =
    typeof overrides.expectedAnswer === 'string' && overrides.expectedAnswer.length > 0
      ? overrides.expectedAnswer
      : typeof overrides.proficiency === 'string'
      ? overrides.proficiency
      : '';

  return {
    ...BASE_LANGUAGE_SCREEN_QUESTION,
    required: false,
    language: typeof language === 'string' ? language : '',
    proficiency: expected,
    expectedAnswer: expected,
    idealWeight: expected ? LANGUAGE_PROFICIENCY_VALUE_MAP[expected] : undefined,
    ...overrides,
    question: overrides.question ?? LANGUAGE_QUESTION_TEXT,
  };
};
